export const contactData = {
  title: "Get In Touch",
  subtitle: "Let's discuss your next project or just say hello",
  
  description: "I'm always open to discussing new projects, creative ideas, or opportunities to be part of your visions.",
  
  contactInfo: [
    {
      icon: 'Mail',
      title: 'Email',
      value: 'sarah.chun.0119@gmail.com',
      link: 'mailto:sarah.chun.0119@gmail.com'
    },
    {
      icon: 'Phone',
      title: 'Phone',
      value: '+1 (236) 971-0699',
      link: 'tel:+12369710699'
    },
    {
      icon: 'MapPin',
      title: 'Location',
      value: 'Richmond, BC, Canada'
    }
  ],
  
  socialLinks: [
    { 
      icon: 'Github', 
      url: 'https://github.com/Chun0119', 
      label: 'GitHub' 
    },
    { 
      icon: 'Linkedin', 
      url: 'https://www.linkedin.com/in/sarah-chun-65819a222/', 
      label: 'LinkedIn' 
    },
    {
      icon: "Mail",
      url: "mailto:sarah.chun.0119@gmail.com",
      label: "Email"
    }
  ]
}; 